import React from 'react'
import { InputComponent } from '../../core/Forms'
import { ICreateExpenseData } from '../../../@types';

interface InvoiceDateProps {
    formData: ICreateExpenseData;
    setFormData: React.Dispatch<React.SetStateAction<ICreateExpenseData>>;
    validationResults: ICreateExpenseData;
    toolTipText?: string;
    setValidationResults: React.Dispatch<
      React.SetStateAction<ICreateExpenseData>
    >;
    handleInputChange: (event: { target: { name: any; value: any } }) => void;
  }

  const ExpenseTitle: React.FC<InvoiceDateProps> = ({
    formData,
    setFormData,
    validationResults,
    toolTipText,
    setValidationResults,
    handleInputChange,
  }) => {
   
  
    return (
     <>
     <div className="form-group">
                 <label
                  htmlFor="expenseTitle"
                  className="lg:text-[14px] md:text-[16px] text-[14px] pb-4 mb-2 font-normal"
                  style={{ whiteSpace: "nowrap" }}
                >
                  {/* {t("budget.expenseDate")} */}
                  Expense Title
                </label>
                    <InputComponent
                       type="text"
                       className="w-full bg-[#F4F7FF] pr-10 whitespace-nowrap py-3  pl-3 !border-[#A4A4A4] mt-2 cursor-pointer text-gray-800 !focus:outline-none outline-none !ring-0 !focus:ring-0 appearance-none"
                       placeholder="Enter expense title"
                       value={formData.name}
                       name="name"
                       handleChange={handleInputChange}
                       error={validationResults.name}
                     />
                     {/* {validationResults.name && (
                <div className="mt-9 mr-[-9em]">
                  <span className="text-red-500">{validationResults.name}</span>
                </div>
              )} */}
     
      </div>
      </>
    );
  };
  
  export default ExpenseTitle;
  